<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
import eruda from 'eruda';
export default {
    data() {
        return {
        };
    },
    
    created() {
        // eruda.init();
        localStorage.setItem('onAuthAppCode', '')
    },
    methods: {
        
    },
};
</script>
<style>
body {
    font-size: 16px;
    background-color: #f8f8f8;
    -webkit-font-smoothing: antialiased;
    
}
</style>
